import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const P2P_ENERGY_FORM_BASE_URL = BASE_URL + "/npcl-requests"
export const URL_CREATE_P2P_ENERGY_FORM_REQUEST = P2P_ENERGY_FORM_BASE_URL + "/create"
